<template>
  <b-modal
    id="clientmodal"
    hide-footer
  >
    <template #modal-title>
      {{ $t('clientmodal.title')}}
    </template>

    <div class="d-flex justify-content-center flex-column">
      <a
        href="https://download.backupmonkey.io/rbm/pkg_remotemonkey_j4_j5.zip"
        class="btn btn-lg btn-primary w-100 text-decoration-none mb-3"
      >
        Joomla! 4.x/5.x
      </a>

      <a
        href="https://download.backupmonkey.io/rbm/pkg_remotemonkey_j3.zip"
        class="btn btn-link text-decoration-none"
      >
        Joomla! 3.x
      </a>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'TheClientModal'
}
</script>
